import * as React from 'react';
import { Icon, IconName, Tooltip } from '@gcl/react-core';
import './UserCell.scss';
import { IProjectRole } from '@role/projectRole/projectRole.models';
import { IProjectTeam } from '@projectTeam/projectTeam.models';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';

export interface IUserCellProps {
  isShowTeam?: boolean;
  team?: IProjectTeam;
  role: IProjectRole;
  hasEditRight?: boolean;
  editUserProfile: (userProfile: IProjectUserProfile, e: any) => void;
  setSelectedCompanyForForm?: () => void;
}

interface IUserStatusProps {
  className?: string;
  content?: string | React.ReactElement;
  icon?: IconName;
}

export const UserCell: React.FunctionComponent<IUserCellProps> = ({
  team,
  role,
  editUserProfile,
  hasEditRight = false,
  isShowTeam,
  setSelectedCompanyForForm,
}) => {
  if (!role.users || role.users.length <= 0 || (isShowTeam && (!team?.users || team.users.length <= 0))) return <></>;

  const getUserStatusProps = (user: IProjectUserProfile): IUserStatusProps => {
    if (!user.id) return {};

    if (user.userProfile?.isResigned) return { className: 'resigned', content: 'Resigned', icon: 'PersonX' };

    if (user.isLocked || user.userProfile?.isLocked) return { className: 'locked', content: 'Locked', icon: 'Lock' };

    if (user?.userProfile?.trainings?.length && user?.userProfile?.trainings?.length > 0) {
      return { className: 'completed', content: 'Completed', icon: 'CheckCircle' };
    }

    return { className: 'enroll', content: <span onClick={() => {}}>Pending</span>, icon: 'PersonWorkspace' };
  };

  const userInfo = (user: IProjectUserProfile) => {
    const { className, content, icon } = getUserStatusProps(user);
    const userDisplayName = user.userProfile?.displayName;

    return (
      <div
        key={`${role.id}-${team?.id}-${user.id ?? user.userProfileId ?? user.userProfile?.id}`}
        className={`gcl-gems-user-cell-user ${className || ''}`}
      >
        <div className="gcl-gems-user-cell-user-name-container">
          <div className={`gcl-gems-user-cell-user-name ${className || ''}`}>{userDisplayName} </div>
          {hasEditRight && editUserProfile && typeof editUserProfile === 'function' ? (
            <Tooltip
              overlay={`Edit ${userDisplayName}`}
              id={`gcl-gems-user-cell-${role.id}-edit-member-${user.id}-btn-tooltip`}
            >
              <Icon
                data-testid={`edit-${userDisplayName}`}
                className="gcl-gems-user-cell-user-action-icon"
                iconName="Pencil"
                onClick={(e) => {
                  if (setSelectedCompanyForForm) setSelectedCompanyForForm();
                  editUserProfile(user, e);
                }}
              />
            </Tooltip>
          ) : undefined}
        </div>
        <div className={`gcl-gems-user-cell-user-status-container ${className || ''}`}>
          {icon ? <Icon className="gcl-gems-user-cell-user-status-icon" iconName={icon} /> : undefined}
          <span className="gcl-gems-user-cell-user-status">{content}</span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="gcl-gems-user-cell-container">
        {isShowTeam &&
          team?.users &&
          team.users
            .filter((user: IProjectUserProfile) =>
              role.users?.some((ruser: IProjectUserProfile) => ruser.id === user.id),
            )
            .map((user) => userInfo(user))}
        {!isShowTeam && role.users.map((user) => userInfo(user))}
      </div>
    </>
  );
};
